import { render, staticRenderFns } from "./fallibleSix.vue?vue&type=template&id=8775ed62&scoped=true"
import script from "./fallibleSix.vue?vue&type=script&lang=js"
export * from "./fallibleSix.vue?vue&type=script&lang=js"
import style0 from "./fallibleSix.vue?vue&type=style&index=0&id=8775ed62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8775ed62",
  null
  
)

export default component.exports